import React, { useEffect, useState } from 'react'
import { left_arrow, search_icon, view_icon } from '../../assets/imgs';
import { Table } from '../../components/Table/Table';
import CommonCurrentDatePicker from '../../components/Dashboard/CommonCurrentDatePicker';
import moment from 'moment';
import { useLazyPropertyChatCountQuery, useLazyPropertyChatDetailCountQuery } from '../redux/api/api';

const ChatList = () => {
    const [list, setList] = useState([])

    const [chatData, setChatData] = useState([])



    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");

    const [chatPageNo, setChatPageNo] = useState(1)
    const [chatPageCount, setChatPageCount] = useState('')

    const [fromDate, setFromDate] = useState(new Date())
    const [toDate, setToDate] = useState(new Date())
    const [show, setShow] = useState(false)
    const [search, setSearch] = useState('')

    //api
    const [overallChatCountApi] = useLazyPropertyChatCountQuery()
    const [chatCountDetailApi] = useLazyPropertyChatDetailCountQuery()


    // console.log('fromDate', moment(fromDate).format('DD-MM-YYYY'))
    // console.log('toDtae', moment(toDate).format('DD-MM-YYYY'))




    const getList = () => {

        let param = `?page=${pageno}`
        if (search) {
            param = param + `&search=${search}`
        }
        if (fromDate && toDate) {
            param = param + "&start_date=" + moment(fromDate).format("YYYY-MM-DD")
                + "&end_date=" + moment(toDate).format("YYYY-MM-DD");
        }



        overallChatCountApi(param)
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    setList(res?.data)
                    setPagecount(res?.pagination)
                }
            }).catch((err) => {
                console.log('err', err)
            })
    }


    const handleView = (id) => {
        let param = `/${id}?page=${chatPageNo}`

        if (fromDate && toDate) {
            param = param + "&start_date=" + moment(fromDate).format("YYYY-MM-DD")
                + "&end_date=" + moment(toDate).format("YYYY-MM-DD");
        }

        // console.log('params', param)

        chatCountDetailApi(param)
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    setChatData(res?.data)
                    setChatPageCount(res?.pagination)
                }
            }).catch((err) => {
                console.log('err', err)
            })
    }


    useEffect(() => {
        getList();

        if (show) {
            handleView(show.id);
        }
    }, [pageno, search, fromDate, toDate, chatPageNo, show]);


    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "s_no",
                Cell: ({ value, row }) => {
                    // return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                    return <p>{value}</p>
                },
            },
            {
                Header: "Property ID",
                accessor: "property_id",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Property Name",
                accessor: "property_name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Chat Count",
                accessor: "chat_count",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">

                                <button
                                    onClick={() => {
                                        setChatPageNo(1);
                                        setShow(row.original);
                                        handleView(row.original.id);
                                    }}
                                    className="cust-btn "
                                >
                                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                </button>

                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );

    // console.log('show', show)

    const columnsTwo = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "s_no",
                Cell: ({ value, row }) => {
                    // return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                    return <p>{value}</p>
                },
            },

            {
                Header: "Date",
                accessor: "date",
                Cell: ({ value, row }) => {
                    return <p>{moment(value).format('DD-MM-YYYY')}</p>;
                },
            },
            {
                Header: "Chat Count",
                accessor: "chat_count",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },

        ],
        []
    );

    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <CommonCurrentDatePicker
                    fromDate={fromDate}
                    setFromDate={setFromDate}
                    toDate={toDate}
                    setToDate={setToDate}
                />

                {!show && (< div className='search-input'>
                    <input value={search} onChange={(e) => setSearch(e.target.value)} type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
                    <img src={search_icon} className='search' />
                </div>)}
            </div>

            {show && (
                <>
                    <div className='d-flex ac-js gap-5'>
                        <div className='d-flex ac-js gap-2'>
                            <p className="f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 ">
                                Property ID:
                            </p>
                            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 ">
                                {show?.property_id}
                            </p>
                        </div>
                        <div className='d-flex ac-js gap-2'>
                            <p className="f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 ">
                                Property Name:
                            </p>
                            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 ">
                                {show?.property_name}
                            </p>
                        </div>
                    </div>
                    <div className='d-flex ac-js gap-2 mt-3'
                        onClick={() => setShow(false)}
                    >
                        <img src={left_arrow} className='leftArrow mb-3' />
                        <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
                    </div>
                </>
            )}
            <Table columns={show ? columnsTwo : columns} data={show ? chatData : list} setPageno={show ? setChatPageNo : setPageno} pagecount={show ? chatPageCount : pagecount} show={true} />
        </div>
    )
}

export default ChatList